export default __webpack_public_path__ + "static/media/logo-text.2dfa3010.svg";